/**
 * Created by olga on 14.11.2024
 */

const UnknownLocation = function (locationConfig) {
    this.locationConfig = locationConfig;
    this.locationId = locationConfig.locationId;

    this.slot = cleverapps.dataSlots.getSlot("fake");
};

UnknownLocation.prototype.checkAvailable = function () {
    return false;
};

UnknownLocation.OnLocationStart = function (locationMeta) {
    throw `Can't start location with unknown type ${JSON.stringify(locationMeta.getInfo())}`;
};

UnknownLocation.OnLocationFinish = function (locationMeta) {
    throw `Can't finish location with unknown type ${JSON.stringify(locationMeta.getInfo())}`;
};

UnknownLocation.GetMainScene = function () {
    throw "Can't switch to unknown location scene";
};